<template>
  <div class="container">
    <div class="header">
      <img class="header-img" src="@/assets/image/logo.png" />
      <label class="header-title">后台管理系统</label>
    </div>
    <div class="body">
      <img class="left-image" src="@/assets/image/login/left.png" />

      <div class="right-form">
        <div class="right-form-inner">
          <label class="form-title">Welcome!</label>
          <el-form :model="user" :rules="rules" ref="formLogin" labelPosition="right" label-width="80px">
            <el-form-item label="用户名" prop="name">
              <el-input class="form-text-input" v-model="user.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input ref="password" class="form-text-input" placeholder="请输入密码" v-model="user.password" show-password v-on:keydown.enter="login('formLogin')"></el-input>
            </el-form-item>
            <div class="form-button">
              <el-button class="form-button-login" type="primary" @click="login('formLogin')">登录</el-button>
            </div>
          </el-form>
        </div>
      </div>

      <img class="down-image" src="@/assets/image/login/down.png" />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ElMessage, ElLoading } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";
import { User } from "@/script/apps/system/entity/SystemEntity";
import { ConfigService } from "@/script/apps/system/service/ConfigService";

@Options({})
export default class Login extends Vue {
  private user: User = { name: "admin", password: "" };  
  private rules = {
    name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
    password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  };

  mounted() {
    this.$nextTick(() => {
      (this.$refs.password as any).focus();
    });    
  }

  login(formName: string) {
    const self = this;
    (this.$refs.formLogin as any).validate((valid: boolean) => {
      if (valid) {
        const loading = ElLoading.service({
          lock: true,
          text: "登录中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const userService = new UserService();
        userService.login(
          this.user,
          function (user: User) {
            loading.close();
            ElMessage.success("登录成功");
            self.$router.push({ path: "/" });
          },
          function (error: Error) {
            loading.close();
            ElMessage.error("登录失败，失败原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
</script>

<style lang="scss">
.container {
  width: 100%;
  height: 100%;
  background: #293058;
}

.header {
  display: flex;
  flex-direction: row;
  padding: 30px;
}

.header-img {
  width: 50px;
  height: 50px;
}

.header-title {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
  align-self: center;
  margin-left: 20px;
}

.body {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 100px;
  margin-top: 60px;
}

.left-image {
  justify-self: right;
  z-index: 1;
}

.down-image {
  position: absolute;
  z-index: 0;
  top: 300px;
}

.right-form {
  z-index: 1;
  width: 520px;
  height: 420px;
  background: #ffffff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1),
    0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  display: grid;
}

.right-form-inner {
  display: grid;
  grid-template-rows: 100px 80px 80px 60px 100px;
  margin: 50px;
}

.form-title {
  font-size: 40px;
  font-weight: 900;
  color: #1b1b25;
  line-height: 50px;
}

.form-label {
  display: block;
  font-size: 10px;
  color: #606266;
}

.form-text-input {
  font-size: 16px;
  margin-top: 5px;
  background: #f8f8fc;
  border: 0px;
  border-radius: 4px;
  height: 38px;
  width: 100%;
}

.form-forget {
  font-size: 14px;
  font-weight: 400;
  color: #606266;
  line-height: 28px;
}

.form-keep {
  align-self: center;
  margin-left: 80px;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #fe6266;
}

.form-keep-label {
  font-size: 14px;
}

.form-button {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

.form-button-login {
  width: 180px;
  height: 42px;
  background: #fe6266;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  border: 0px;
  border-radius: 4px;
}
</style>
